
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'newgoodsapprovalIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'newgoodsapproval',
				windowName: '新品立项',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
